<section>
  <div
    class="ds-field"
    [class.ds-fluid]="fluid"
    [class.ds-invalid]="validate && isTouched && isInvalid"
    [class.ds-valid]="validate && isTouched && isValid"
  >
    <input
      #inputElement
      type="text"
      placeholder=" "
      [id]="id"
      [pattern]="pattern"
      [attr.aria-invalid]="isInvalid"
      [attr.aria-describedby]="'alert-' + id"
    />
    <span
      [class]="'ds-icon ds-cursor-pointer ds-outline-none ' + currentDateIcon"
      tabindex="0"
      (click)="onOpenChange()"
      (keydown.space)="onOpenChange()"
      (keydown.enter)="onOpenChange()"
    >
    </span>
    <label [for]="id">
      <ng-template [ngIf]="label">{{ label }}</ng-template>
      <ng-template [ngIf]="!label">
        <ng-content></ng-content>
      </ng-template>
    </label>
  </div>
  <div class="ds-text-xs ds-mt-2xs" [id]="'alert-' + id">
    <span role="alert" class="ds-text-secondary-red ds-opacity-80">
      {{ error }}
    </span>
    <span class="ds-text-tertiary-mediumgrey">
      {{ hint }}
    </span>
  </div>
  <ui-input-calendar
    *ngIf="open"
    type="date"
    [fluid]="fluid"
    [(activeDate)]="activeDate"
    (valueChange)="onDateChange($event!)"
    [weekday]="weekday"
    [value]="valueAsDate"
    [min]="minAsDate"
    [max]="maxAsDate"
  >
  </ui-input-calendar>
</section>
